import { supabase } from './authService';

export interface InquiryDB {
    id: string;
    user_id: string;
    title: string;
    content: string;
    status: 'pending' | 'answered' | 'closed';
    category?: string;
    answer?: string;
    answered_at?: string;
    created_at: string;
    updated_at: string;
    user?: {
        name: string;
        email: string;
    };
}

export const createInquiry = async (userId: string, title: string, content: string, category: string) => {
    const { data, error } = await supabase
        .from('inquiries')
        .insert([
            {
                user_id: userId,
                title,
                content,
                category,
                status: 'pending'
            }
        ])
        .select()
        .single();

    if (error) throw error;
    return data;
};

export const fetchUserInquiries = async (userId: string): Promise<InquiryDB[]> => {
    const { data, error } = await supabase
        .from('inquiries')
        .select('*')
        .eq('user_id', userId)
        .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
};

export const fetchAllInquiries = async (): Promise<InquiryDB[]> => {
    // 1. 모든 문의 데이터 가져오기
    const { data: inquiries, error: inqError } = await supabase
        .from('inquiries')
        .select('*')
        .order('created_at', { ascending: false });

    if (inqError) throw inqError;
    if (!inquiries || inquiries.length === 0) return [];

    // 2. 유니크한 사용자 ID 목록 추출
    const userIds = Array.from(new Set(inquiries.map(i => i.user_id)));

    // 3. 사용자 정보 가져오기
    const { data: users, error: userError } = await supabase
        .from('user')
        .select('id, name, email')
        .in('id', userIds);

    if (userError) throw userError;

    // 4. 데이터 병합
    const userMap = new Map(users?.map(u => [u.id, u]));
    
    return inquiries.map(inq => ({
        ...inq,
        user: userMap.get(inq.user_id)
    }));
};

export const updateInquiryStatus = async (inquiryId: string, status: string, answer?: string) => {
    const updateData: any = { 
        status, 
        updated_at: new Date().toISOString() 
    };
    
    if (answer !== undefined) {
        updateData.answer = answer;
        updateData.answered_at = new Date().toISOString();
    }

    const { data, error } = await supabase
        .from('inquiries')
        .update(updateData)
        .eq('id', inquiryId)
        .select()
        .single();

    if (error) throw error;
    return data;
};
